// Generated by Melange

import * as Buhta_cabinet__Btn from "../../../html/Btn.js";
import * as Buhta_cabinet__DashboardContentTemplate from "../../../../templates/DashboardContentTemplate.js";
import * as Buhta_cabinet__OrgDashboardHeader from "../../../molecules/OrgDashboardHeader/OrgDashboardHeader.js";
import * as Buhta_cabinet__Route from "../../../../Route.js";
import * as Buhta_components__Text from "../../../../../../../packages/components/src/html/Text.js";
import * as Buhta_core__Tenant from "../../../../../../../packages/core/lib/Tenant.js";
import * as Curry from "melange.js/curry.js";
import * as StaticAsset from "../../../../../../../packages/util/lib/StaticAsset.js";
import * as Stdlib__List from "melange/list.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";

function TaxPaymentsOrdersCheckout(Props) {
  let org = Props.org;
  const match = Buhta_core__Tenant.useTenant(undefined);
  const tenant = match[0];
  const contextRoute = function (route) {
    return Buhta_cabinet__Route.contextRoute(tenant.ctx, org.id, route);
  };
  const match$1 = React.useState(function () {
        return true;
      });
  const setIsVisible = match$1[1];
  const isVisible = match$1[0];
  const header = JsxRuntime.jsx(Buhta_cabinet__OrgDashboardHeader.make, {
        title: "Налоги за руководителя и сотрудников",
        route: contextRoute({
              TAG: /* Tax */4,
              _0: {
                TAG: /* Payments */0,
                _0: /* Orders */{
                  _0: /* Index */0
                }
              }
            })
      });
  return JsxRuntime.jsxs(Buhta_cabinet__DashboardContentTemplate.make, {
              header: header,
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                          className: "text-default-gray font-semibold mb-4",
                                          children: "ОБЩАЯ ИНФОРМАЦИЯ О НАЛОГОПЛАТИЛЬЩИКЕ"
                                        }),
                                    JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                  className: "text-gray-medium w-[200px]",
                                                  children: "ИИН/БИН"
                                                }),
                                            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                  children: "861202400332"
                                                })
                                          ],
                                          className: "flex gap-2"
                                        }),
                                    JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                  className: "text-gray-medium w-[200px]",
                                                  children: "Название"
                                                }),
                                            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                  children: "ИП \"Нурпеисов\""
                                                })
                                          ],
                                          className: "flex gap-2"
                                        }),
                                    JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                  className: "text-gray-medium w-[200px]",
                                                  children: "Период"
                                                }),
                                            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                  children: "Июнь 2024"
                                                })
                                          ],
                                          className: "flex gap-2"
                                        }),
                                    JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                  className: "text-gray-medium min-w-[200px] overflow-hidden whitespace-nowrap overflow-ellipsis",
                                                  children: "Налоговая по месту нахождения"
                                                }),
                                            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                  className: "overflow-hidden whitespace-nowrap overflow-ellipsis",
                                                  children: "УГД \"Парк информационных технологий\""
                                                }),
                                            JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                  className: "text-gray-medium",
                                                  children: "6004"
                                                })
                                          ],
                                          className: "flex gap-2"
                                        })
                                  ],
                                  className: "flex flex-col gap-2"
                                }),
                            className: "flex flex-col gap-6 p-10"
                          }),
                      className: "bg-white w-[562px] rounded-md"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("div", {
                            children: JsxRuntime.jsxs("div", {
                                  children: [
                                    JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                          className: "text-default-gray font-semibold",
                                          children: "РУКОВОДИТЕЛЬ ПРЕДПРИЯТИЯ"
                                        }),
                                    JsxRuntime.jsx("div", {
                                          children: JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsxs("div", {
                                                        children: [
                                                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                className: "!font-mediumbold",
                                                                children: "Нурпеисов Асет Канатович"
                                                              }),
                                                          JsxRuntime.jsxs("div", {
                                                                children: [
                                                                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                        className: "text-gray-medium",
                                                                        children: "Доход руководителя за июнь"
                                                                      }),
                                                                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                        className: "font-mediumbold",
                                                                        children: "85 000 ₸"
                                                                      })
                                                                ],
                                                                className: "flex gap-2"
                                                              }),
                                                          JsxRuntime.jsxs("div", {
                                                                children: [
                                                                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                        className: "text-gray-medium",
                                                                        children: "К оплате"
                                                                      }),
                                                                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                        className: "font-mediumbold",
                                                                        children: "18 700 ₸"
                                                                      })
                                                                ],
                                                                className: "flex gap-2"
                                                              })
                                                        ],
                                                        className: "flex flex-col gap-1"
                                                      }),
                                                  JsxRuntime.jsx("img", {
                                                        className: "w-5 h-5",
                                                        alt: "more",
                                                        src: StaticAsset.src("/static/icons/arrow-down-gray.svg")
                                                      })
                                                ],
                                                className: "flex items-center justify-between"
                                              }),
                                          className: "flex flex-col p-4 border border-gray-main rounded mb-2"
                                        }),
                                    JsxRuntime.jsxs("div", {
                                          children: [
                                            JsxRuntime.jsx("img", {
                                                  className: "w-5 h-5",
                                                  alt: "more",
                                                  src: StaticAsset.src("/static/icons/arrow-down-gray.svg")
                                                }),
                                            JsxRuntime.jsx(Buhta_components__Text.Caption.make, {
                                                  className: "text-default-gray font-semibold",
                                                  children: "СОТРУДНИКИ"
                                                })
                                          ],
                                          className: "flex items-center gap-2"
                                        }),
                                    JsxRuntime.jsx("div", {
                                          children: JsxRuntime.jsx("div", {
                                                children: JsxRuntime.jsxs("div", {
                                                      children: [
                                                        JsxRuntime.jsxs("div", {
                                                              children: [
                                                                JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                      className: "!font-mediumbold",
                                                                      children: "Абильденов Абилкасым Ерланович"
                                                                    }),
                                                                JsxRuntime.jsx("button", {
                                                                      children: isVisible ? JsxRuntime.jsx("img", {
                                                                              className: "w-5 h-5",
                                                                              alt: "more",
                                                                              src: StaticAsset.src("/static/icons/arrow-up.svg")
                                                                            }) : null,
                                                                      onClick: (function (param) {
                                                                          Curry._1(setIsVisible, (function (prevState) {
                                                                                  return !prevState;
                                                                                }));
                                                                        })
                                                                    })
                                                              ],
                                                              className: "flex items-center justify-between"
                                                            }),
                                                        isVisible ? JsxRuntime.jsxs("div", {
                                                                children: [
                                                                  JsxRuntime.jsx("hr", {
                                                                        className: "my-4"
                                                                      }),
                                                                  JsxRuntime.jsxs("div", {
                                                                        children: [
                                                                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                                className: "text-asphalt-dark",
                                                                                children: "Зарплата на руки"
                                                                              }),
                                                                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                                children: "100 000 ₸"
                                                                              })
                                                                        ],
                                                                        className: "flex justify-between"
                                                                      }),
                                                                  JsxRuntime.jsxs("div", {
                                                                        children: [
                                                                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                                className: "text-asphalt-dark",
                                                                                children: "Зарплата с налогами"
                                                                              }),
                                                                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                                children: "100 000 ₸"
                                                                              })
                                                                        ],
                                                                        className: "flex justify-between"
                                                                      }),
                                                                  JsxRuntime.jsxs("div", {
                                                                        children: [
                                                                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                                className: "text-asphalt-dark",
                                                                                children: "Обязательные пенсионные взносы"
                                                                              }),
                                                                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                                children: "8 500 ₸"
                                                                              })
                                                                        ],
                                                                        className: "flex justify-between mt-3"
                                                                      }),
                                                                  JsxRuntime.jsxs("div", {
                                                                        children: [
                                                                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                                className: "text-asphalt-dark",
                                                                                children: "Взносы на соц. мед. страхование"
                                                                              }),
                                                                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                                children: "5 955 ₸"
                                                                              })
                                                                        ],
                                                                        className: "flex justify-between"
                                                                      }),
                                                                  JsxRuntime.jsxs("div", {
                                                                        children: [
                                                                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                                className: "text-asphalt-dark",
                                                                                children: "Индивидуальный подоходный налог"
                                                                              }),
                                                                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                                children: "5 955 ₸"
                                                                              })
                                                                        ],
                                                                        className: "flex justify-between"
                                                                      }),
                                                                  JsxRuntime.jsxs("div", {
                                                                        children: [
                                                                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                                className: "text-asphalt-dark",
                                                                                children: "Обязательные пенсионные взносы работодателя"
                                                                              }),
                                                                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                                children: "1 275 ₸"
                                                                              })
                                                                        ],
                                                                        className: "flex justify-between"
                                                                      }),
                                                                  JsxRuntime.jsxs("div", {
                                                                        children: [
                                                                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                                className: "text-asphalt-dark",
                                                                                children: "Отчисления на соц. мед. страхование"
                                                                              }),
                                                                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                                children: "1 275 ₸"
                                                                              })
                                                                        ],
                                                                        className: "flex justify-between"
                                                                      }),
                                                                  JsxRuntime.jsxs("div", {
                                                                        children: [
                                                                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                                className: "text-asphalt-dark",
                                                                                children: "Социальные отчисления"
                                                                              }),
                                                                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                                children: "2 975 ₸"
                                                                              })
                                                                        ],
                                                                        className: "flex justify-between"
                                                                      }),
                                                                  JsxRuntime.jsxs("div", {
                                                                        children: [
                                                                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                                className: "text-asphalt-dark !font-mediumbold",
                                                                                children: "Итого за налоги"
                                                                              }),
                                                                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                                className: "!font-mediumbold",
                                                                                children: "18 700 ₸"
                                                                              })
                                                                        ],
                                                                        className: "flex justify-between mt-3"
                                                                      })
                                                                ],
                                                                className: "flex flex-col gap-1"
                                                              }) : JsxRuntime.jsxs("div", {
                                                                children: [
                                                                  JsxRuntime.jsxs("div", {
                                                                        children: [
                                                                          JsxRuntime.jsxs("div", {
                                                                                children: [
                                                                                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                                        className: "text-gray-medium",
                                                                                        children: "Зарплата"
                                                                                      }),
                                                                                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                                        className: "font-mediumbold",
                                                                                        children: "85 000 ₸"
                                                                                      })
                                                                                ],
                                                                                className: "flex gap-2"
                                                                              }),
                                                                          JsxRuntime.jsxs("div", {
                                                                                children: [
                                                                                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                                        className: "text-gray-medium",
                                                                                        children: "К оплате"
                                                                                      }),
                                                                                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                                        className: "font-mediumbold",
                                                                                        children: "18 700 ₸"
                                                                                      }),
                                                                                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                                        className: "font-mediumbold text-success",
                                                                                        children: "Частично освобожден"
                                                                                      })
                                                                                ],
                                                                                className: "flex gap-2"
                                                                              })
                                                                        ],
                                                                        className: "flex flex-col"
                                                                      }),
                                                                  JsxRuntime.jsx("button", {
                                                                        children: JsxRuntime.jsx("img", {
                                                                              className: "w-5 h-5",
                                                                              alt: "more",
                                                                              src: StaticAsset.src("/static/icons/arrow-down-gray.svg")
                                                                            }),
                                                                        onClick: (function (param) {
                                                                            Curry._1(setIsVisible, (function (prevState) {
                                                                                    return !prevState;
                                                                                  }));
                                                                          })
                                                                      })
                                                                ],
                                                                className: "flex items-start justify-between"
                                                              })
                                                      ],
                                                      className: "flex flex-col gap-1"
                                                    })
                                              }),
                                          className: "flex flex-col p-4 border border-gray-main rounded"
                                        }),
                                    Stdlib__List.length({
                                          hd: "",
                                          tl: /* [] */0
                                        }) > 0 ? JsxRuntime.jsx("div", {
                                            children: JsxRuntime.jsx("div", {
                                                  children: JsxRuntime.jsxs("div", {
                                                        children: [
                                                          JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                className: "!font-mediumbold",
                                                                children: "Абильденов Абилкасым Ерланович"
                                                              }),
                                                          JsxRuntime.jsxs("div", {
                                                                children: [
                                                                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                        className: "text-gray-medium",
                                                                        children: "Зарплата"
                                                                      }),
                                                                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                        className: "font-mediumbold",
                                                                        children: "85 000 ₸"
                                                                      })
                                                                ],
                                                                className: "flex gap-2"
                                                              }),
                                                          JsxRuntime.jsxs("div", {
                                                                children: [
                                                                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                        className: "text-gray-medium",
                                                                        children: "К оплате"
                                                                      }),
                                                                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                        className: "font-mediumbold",
                                                                        children: "18 700 ₸"
                                                                      }),
                                                                  JsxRuntime.jsx(Buhta_components__Text.PSmall.make, {
                                                                        className: "font-mediumbold text-success",
                                                                        children: "Частично освобожден"
                                                                      })
                                                                ],
                                                                className: "flex gap-2"
                                                              })
                                                        ],
                                                        className: "flex flex-col gap-1"
                                                      }),
                                                  className: "flex items-center justify-between"
                                                }),
                                            className: "flex flex-col p-4 border border-gray-main rounded"
                                          }) : null
                                  ],
                                  className: "flex flex-col gap-4"
                                }),
                            className: "flex flex-col gap-6 p-10"
                          }),
                      className: "bg-white w-[562px] rounded-md"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx(Buhta_cabinet__Btn.make, {
                              title: "Изменить",
                              color: /* Transparent */1,
                              className: "border border-gray-main rounded px-6 py-3",
                              type_: "submit"
                            }),
                        JsxRuntime.jsx(Buhta_cabinet__Btn.make, {
                              title: "Оплатить 127 911 ₸",
                              className: "px-6 py-3",
                              type_: "submit"
                            })
                      ],
                      className: "w-[562px] flex justify-between mt-6"
                    })
              ],
              className: "bg-gray-pale py-10 flex-col items-center gap-2"
            });
}

const make = TaxPaymentsOrdersCheckout;

export {
  make ,
}
/* Buhta_cabinet__Btn Not a pure module */
